/**
 * «Показывали ли тизер ассистента сегодня».
 *
 * userId в ключе — чтобы на общем компьютере закрытие одним пользователем не наследовалось
 * следующим. Дата в значении, а не в ключе — чтобы не плодить по записи в localStorage за день.
 */

const KEY_PREFIX = "auf.assistant.teaser.";

function storageKey(userId) {
  return `${KEY_PREFIX}${userId ?? "anon"}`;
}

function today() {
  return new Date().toISOString().slice(0, 10);
}

export function isTeaserDismissedToday(userId) {
  try {
    return localStorage.getItem(storageKey(userId)) === today();
  } catch {
    // Приватный режим / отключённое хранилище — считаем, что не показывали.
    return false;
  }
}

export function dismissTeaserForToday(userId) {
  try {
    localStorage.setItem(storageKey(userId), today());
  } catch {
    // Не критично: в худшем случае тизер покажется ещё раз.
  }
}
